import React, { forwardRef, HTMLAttributes } from "react";
import classNames from "classnames";

export type FooterProps = HTMLAttributes<HTMLDivElement>;

export const Footer = forwardRef<HTMLDivElement, FooterProps>(({ className, children, ...rest }, ref) => {
  return (
    <div {...rest} ref={ref} className={classNames("ui-bottom-sheet-dialog-footer", className)}>
      {children}
    </div>
  );
});

Footer.displayName = "BottomSheet.Footer";
